import { useStore } from 'store/store';
import styled from 'styled-components';

export const Name = styled.div`
  margin-bottom: 2px;
  color: ${({ theme }) => theme.color.additional.dark.value};
  font-size: 16px;
  font-weight: 400;
  font-variation-settings: 'WDTH' 60.2;
  a {
    text-decoration: none;
    color: ${({ theme }) => theme.color.additional.dark.value};
  }
  a:visited {
    text-decoration: none;
    color: ${({ theme }) => theme.color.additional.dark.value};
  }
  a:hover {
    border-color: transparent;
    cursor: pointer;
    color: ${() => {
      const headerConfig = useStore((state) => state.headerConfig);
      return headerConfig.tagSelected;
    }};
  }
`;
